import _ from "lodash";
import { AppState } from "./state";

export type Reducer = (prevState: AppState, action: any) => AppState;

// Reducer
export function reducer(prevState: AppState, action: any) {
    const newState = _.clone(prevState);

	switch (action.type) {
		case 'BOOT_COMPLETED':
		case 'UPDATE':
			break;
		case 'DESIGN_UPDATE':
			newState.environment.renderDesign();
			break;
		case 'PARAMETERS_RECEIVED':
			newState.parametersReceived = true;
			break;
		case 'UPDATE_VIEW':
			newState.environment.updateView();
			break;
		case 'SWITCH_FULLSCREEN':
			newState.environment.switchFullscreen();
			break;
		case 'SELECT_OPTION':
			newState.environment.selectOption(action.optionId);
			break;
		case 'APPEND_VIEWER':
			newState.environment.appendViewer(action.container);
			break;
		case 'SET_HIGHLIGHT_SETTINGS':
			newState.environment.setHighlightSettings(action.settings);
		case 'IS_SCENE_LOADING':
			newState.isSceneLoading = action.isLoading;
			break;
		case 'IS_ADD_TO_CART_LOADING':
			newState.isAddToCartLoading = action.isLoading;
			break;
		case 'SET_TEMPLATE':
			newState.environment.setTemplate(action.templateId);
			break;
		case 'SET_ITEM_IMAGE_FROM_BASE64':
			newState.environment.setItemImageFromBase64(action.guid, action.base64);
			break;
		case 'SET_ITEM_IMAGE_FROM_FILE':
			newState.environment.setItemImageFromFile(action.guid, action.file);
			break;
		case 'ADD_ITEM_IMAGE':
			newState.environment.addItemImage(action.imageId, action.areaId);
			break;
		case 'SET_ITEM_IMAGE':
			newState.environment.setItemImage(action.guid, action.imageId);
			break;
		case 'SET_ITEM_FONT_FAMILY':
			newState.environment.setItemFontFamily(action.guid, action.fontFamily);
			break;
		case 'SET_ITEM_COLOR':
			newState.environment.setItemColor(action.guid, action.color);
			break;
		case 'SET_ITEM_BOLD':
			newState.environment.setItemBold(action.guid, action.bold);
			break;
		case 'SET_ITEM_ITALIC':
			newState.environment.setItemItalic(action.guid, action.italic);
			break;
		case 'SET_ITEM_TEXT_PATH':
			newState.environment.setItemTextOnPath(action.guid, action.areaId, action.value);
			break;
		case 'SET_ITEM_TEXT':
			newState.environment.setItemText(action.guid, action.text);
			break;
		case 'ADD_ITEM_TEXT':
			newState.environment.addItemText(action.settings, action.areaId);
			break;
		case 'REMOVE_ITEM':
			newState.environment.removeItem(action.guid);
			break;
		case 'ZOOM_IN':
			newState.environment.zoomIn();
			break;
		case 'ZOOM_OUT':
			newState.environment.zoomOut();
			break;
		case 'SET_EXPLODED_MODE':
			newState.environment.setExplodedMode(action.exploded);
			break;
		case 'DEBUG_MODE':
			console.log('Debug mode ', !newState.isDebug ? 'enabled' : 'disabled');
			newState.isDebug = !newState.isDebug;
			break;
		case 'VIEWER':
			console.log(action);
			newState.sceneViewer = action.value;
			break;
		case 'CUSTOMIZER':
			console.log(action);
			newState.customizer = action.customizer;
			newState.environment.visibleCustomizer = action.customizer;
			break;
		default:
			throw new Error(`Invalid reducer action ${action.type}.`);
	}

    return newState;
}